// extracted by mini-css-extract-plugin
export default {"description":"radio_description__+yZas","label":"radio_label__TUMky"};